// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"83":"41afc9f4","373":"45f27a28","428":"41afc9f4","723":"939a57c7","773":"428027cc"}[chunkId] + ".chunk.css";
};